import React from "react";
import { MODULE_NAME, MODULE_UI_NAME } from "../moduleName";
import {
  AppBar,
  AppBarProps,
} from "@ofqual/portal-components/components/SecondaryAppBar";

type NewsAppBarProps = Omit<AppBarProps, "moduleName">;

export const NewsAppBar: React.FC<NewsAppBarProps> = ({
  children,
  breadcrumbs = [],
}) => {
  const rootBreadcrumb = {
    label: MODULE_UI_NAME,
  };

  return (
    <AppBar
      moduleName={MODULE_NAME}
      breadcrumbs={[rootBreadcrumb, ...breadcrumbs]}
    >
      {children}
    </AppBar>
  );
};
